import { registerBlockType } from '@wordpress/blocks';

export default blocks => {
  return blocks.map(item => {
    return registerBlockType(item.name, item.settings);
  });
};
